module.exports = "pegasus/assets/preview-10.png";